export default "__VITE_ASSET__ea99bc69__"